import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { Theme } from '@mui/material';

import { makeStyles } from 'tss-react/mui';
import { ContentTemplate, Grid, KeyValue, Progress, Typography } from 'web-library';
import { candidateService } from '../../../../../api';
import ReviewApplicationContent from './ReviewApplicationContent';
import ReviewMedicalConditionReason from './ReviewMedicalConditionReason';
import DocumentBadge from '../../../../../components/DocumentBadge';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  subheader: {
    marginBottom: theme.spacing(4),
  },
  keyValueContainer: {
    marginTop: theme.spacing(2),
  },
  documentsContainer: {
    marginTop: theme.spacing(1.5),
  },
  documentBadgeContainer: {
    marginTop: theme.spacing(4),
  },
}));

const ReviewAmendment = () => {
  const { t } = useTranslation();
  const { uuid } = useParams<{ uuid: string }>();
  const [dataFetched, setDateFetched] = useState(false);
  const { classes } = useStyles();

  const {
    data,
  } = candidateService.accessArrangement.candidate.useGetReviewAmendmentApplicationData(uuid, () =>
    setDateFetched(true)
  );

  const { data: individualReportDraftFiles } =
    candidateService.accessArrangement.candidate.useGetIndividualReportFiles(uuid);

  const { data: individualReportSubmittedFiles } =
    candidateService.accessArrangement.candidate.useGetIndividualReportSubmittedFiles(uuid);

  if (!dataFetched || !data) {
    return (
      <ContentTemplate transparent continuous>
        <Progress color="secondary" />
      </ContentTemplate>
    );
  }

  return (
    <>
      {dataFetched && (
        <ReviewApplicationContent
          amendment
          data={data}
          medicalConditionReason={
            <>
            <ContentTemplate isDividerBottom continuous>
              <Typography variant="h2" className={classes.subheader}>
                {t('accessArrangement->>ReviewApplication.Subheader2')}
              </Typography>
              {data.medicalConditionAmendmentModel.medicalConditionDraftModel && (
                <ReviewMedicalConditionReason
                  medicalConditionLabel={t(
                    'accessArrangement->>ReviewApplication.AdditionalMedicalCondition'
                  )}
                  reasonLabel={t('accessArrangement->>ReviewApplication.AddedReason')}
                  documentLabel={t('accessArrangement->>ReviewApplication.AddedDocuments')}
                  medicalConditionModel={
                    data.medicalConditionAmendmentModel.medicalConditionDraftModel
                  }
                  requiredField={false}
                />
              )}
              {data.medicalConditionAmendmentModel.medicalConditionSubmittedModel && (
                <ReviewMedicalConditionReason
                  medicalConditionLabel={t(
                    'accessArrangement->>ReviewApplication.SubmittedMedicalCondition'
                  )}
                  reasonLabel={t('accessArrangement->>ReviewApplication.SubmittedReason')}
                  documentLabel={t('accessArrangement->>ReviewApplication.SubmittedDocuments')}
                  medicalConditionModel={
                    data.medicalConditionAmendmentModel.medicalConditionSubmittedModel
                  }
                />
              )}
            </ContentTemplate>
            <ContentTemplate continuous>
              <Typography variant="h2" className={classes.subheader}>
                {t('accessArrangement->>ReviewApplication.IndividualReport')}
              </Typography>
              {individualReportDraftFiles && individualReportDraftFiles.length > 0 && (
                <Grid className={classes.keyValueContainer}>
                  <KeyValue
                    id="individual-report-draft-documents"
                    keyText={t('accessArrangement->>ReviewApplication.AddedDocuments')}
                    valueText={
                      <Grid className={classes.documentsContainer}>
                        {individualReportDraftFiles.map((doc, index) => (
                          <DocumentBadge
                            key={doc.fileUuid}
                            className={index !== 0 ? classes.documentBadgeContainer : ''}
                            documentName={doc.fileName}
                          />
                        ))}
                      </Grid>
                    }
                  />
                </Grid>
              )}
              {individualReportSubmittedFiles && individualReportSubmittedFiles.length > 0 && (
                <Grid className={classes.keyValueContainer}>
                  <KeyValue
                    id="individual-report-submitted-documents"
                    keyText={t('accessArrangement->>ReviewApplication.SubmittedDocuments')}
                    valueText={
                      <Grid className={classes.documentsContainer}>
                        {individualReportSubmittedFiles.map((doc, index) => (
                          <DocumentBadge
                            key={doc.fileUuid}
                            className={index !== 0 ? classes.documentBadgeContainer : ''}
                            documentName={doc.fileName}
                          />
                        ))}
                      </Grid>
                    }
                  />
                </Grid>
              )}
            </ContentTemplate>
            </>
          }
        />
      )}
    </>
  );
};

export default ReviewAmendment;
